// extracted by mini-css-extract-plugin
module.exports = {"themecolor":"#25215e"};